export default {
  data() {
    return {
      validationErrors: [],
    };
  },

  methods: {
    getCardType(cardName) {
      if (this.validationErrors.indexOf(cardName) !== -1) {
        return 'danger';
      }

      return 'dark';
    },

    getInputClass(inputName) {
      const classes = ['form-control', 'bg-light'];
      if (this.validationErrors.indexOf(inputName) !== -1) {
        classes.push('is-invalid');
      }
      return classes.join(' ');
    },

    resetValidation() {
      this.validationErrors = [];
    },

    setInvalidFields(fields) {
      this.resetValidation();
      const mappedFields = fields.map(field => field.field);
      this.validationErrors = this.validationErrors.concat(mappedFields);
    },
  },
};
